import { DEFAULT_LANGUAGE, Languages } from "../hooks/language/language.types";

export const getUrlWithLang = (language: Languages, url: string) => {
    const baseUrl = `/${language === DEFAULT_LANGUAGE ? "" : language + "/"}${url}`
    const baseUrlClean = baseUrl[baseUrl.length - 1] === "/" ? baseUrl.slice(0, -1) : baseUrl;
    return baseUrlClean
}

export function nameToUrlFormatted(name: string): string {
    return name
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, "") // Delete points less -
        .replace(/\s+/g, "-");  // change white space to -
}